import { FC, useEffect, useRef, useState } from 'react';
import { Card, Box, Grid, Stack, Typography, Modal } from '@mui/material';
import Container from '@mui/material/Container';
import "../../index.css"
import { Link as RouterLink } from 'react-router-dom';
import SigninForm from './SigninForm';
import HomeHeader from './HomeHeader';
// import loginImage from '../.././login-image.png';

import BgImg0 from './images/bg-registration-form-2.jpg';
import BgImg from './images/header/banner-bg.svg';
import BgImg2 from './images/bg2.png';
import Img0 from './images/icon.png';
import Img1 from './images/wareozo-light.png';
import Img01 from './images/wareozo.png';
import Img2 from './images/header/header-hero.png';
import Img3 from './images/brands/uideck.svg';
import Img4 from './images/brands/ayroui.svg';
import Img5 from './images/brands/graygrids.svg';
import Img6 from './images/brands/lineicons.svg';
import Img7 from './images/brands/ecommerce-html.svg';
import Img8 from './images/services/services-shape.svg';
import Img9 from './images/services/services-shape-1.svg';
import Img10 from './images/services/services-shape-2.svg';
import Img11 from './images/services/services-shape-3.svg';
import Img12 from './images/about/about1.svg';
import Img13 from './images/about/about-shape-1.svg';
import Img14 from './images/about/about-shape-2.svg';
import Img15 from './images/about/about2.svg';
import Img16 from './images/about/about3.svg';
import Img17 from './images/video/video.png';
import Img18 from './images/video/dots.svg';
// import { Helmet } from "react-helmet";
import SignUpForm from '../SignUp/SignUpForm';
import ForgotPassword from '../ForgotPassword/ForgotPassword';


/**
 * Sign In form Component. 
 */
// export function AddLibrary(urlOfTheLibrary:string) {
//   const script = document.createElement("script");
//   script.src = urlOfTheLibrary;
//   script.async = true;
//   document.body.appendChild(script);
// }



const TermsConditions: FC = () => {

  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(true);
  const [scrolled, setScrolled] = useState(false);
  const [menu, setMenu] = useState(false);
  const [type, setType] = useState('0');

  const navRef = useRef<any>()

  const [width, setWidth] = useState<number>(window.innerWidth);

  function handleWindowSizeChange() {
    setWidth(window.innerWidth);
  }

  useEffect(() => {
    import('./css/animate.css');
    import('./css/glightbox.min.css');
    import('./css/lineicons.css');
    import('./css/bootstrap.min.css');
    import('./css/style.css');
    import('./css2/style.css');
    window.addEventListener('resize', handleWindowSizeChange);
    return () => {
      window.removeEventListener('resize', handleWindowSizeChange);
    }
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      const { offsetTop } = navRef.current
      if (window.pageYOffset > offsetTop) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    }
    window.addEventListener('scroll', handleScroll)
    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [])

  const isMobile = width <= 768;

  useEffect(() => {
    setTimeout(() => {
      setLoading(false)
    }, 1200);
  }, [])
  return (
    <>

      {loading && <div className="preloader">
        <div className="loader">
          <div className="spinner">
            <div className="spinner-container">
              <div className="spinner-rotator">
                <div className="spinner-left">
                  <div className="spinner-circle"></div>
                </div>
                <div className="spinner-right">
                  <div className="spinner-circle"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>}

      <header className="header-area" style={{marginTop: '-64px'}}>
        <div ref={navRef} className={`navbar-area ${scrolled && 'sticky'}`}>
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <nav className="navbar navbar-expand-lg">
                  <a className="navbar-brand" href="/signin">
                    <img src={Img0} alt="Logo" style={{ width: isMobile ? scrolled ? 40 : 60 : scrolled ? 50 : 80 }} />
                    <img src={scrolled ? Img01 : Img1} alt="Logo" style={{ width: isMobile ? scrolled ? 80 : 120 : scrolled ? 120 : 150 }} />
                  </a>
                  <button
                    className={`navbar-toggler ${menu && 'active'}`}
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#navbarSupportedContent"
                    aria-controls="navbarSupportedContent"
                    aria-expanded="false"
                    aria-label="Toggle navigation"
                    onClick={() => setMenu(!menu)}
                  >
                    <span className="toggler-icon"> </span>
                    <span className="toggler-icon"> </span>
                    <span className="toggler-icon"> </span>
                  </button>

                  <div
                    className={`collapse navbar-collapse sub-menu-bar ${menu && 'show'}`}
                    id="navbarSupportedContent"
                  >
                    <ul id="nav" className="navbar-nav ms-auto">
                      <li className="nav-item" onClick={() => setMenu(!menu)}>
                        <a className="page-scroll" href="/signin#home">Home</a>
                      </li>
                      <li className="nav-item" onClick={() => setMenu(!menu)}>
                        <a className="page-scroll" href="/signin#features">Features</a>
                      </li>
                      <li className="nav-item" onClick={() => setMenu(!menu)}>
                        <a className="page-scroll" href="/signin#pricing">Pricing</a>
                      </li>
                      <li className="nav-item" onClick={() => setMenu(!menu)}>
                        <a className="page-scroll" href="/signin#about">About</a>
                      </li>
                      <li className="nav-item" onClick={() => setMenu(!menu)}>
                        <a className="page-scroll" href="/signin#facts">Why</a>
                      </li>
                      <li className="nav-item" onClick={() => setMenu(!menu)}>
                        <a href="/signin#faq">faq</a>
                      </li>
                    </ul>
                  </div>

                  <div className="navbar-btn d-none d-sm-inline-block">
                    <a
                      className="main-btn"
                      style={{ backgroundColor: scrolled ? '#059669' : '#fff', color: scrolled ? '#fff' : '#059669', border: '2px solid #059669', textDecoration: 'none' }}
                      data-scroll-nav="0"
                      onClick={() => setOpen(!open)}
                      // href="https://uideck.com/templates/basic/"
                      rel="nofollow"
                    >
                      Login Now
                    </a>
                  </div>
                </nav>
              </div>
            </div>
          </div>
        </div>

        <div
          id="home"
          className="header-hero bg_cover"
          style={{ backgroundImage: `url(${BgImg})` }}

        >
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-8">
                <div className="header-hero-content text-center">
                  {/* <h3
                    className="header-sub-title wow fadeInUp"
                    data-wow-duration="1.3s"
                    data-wow-delay="0.2s"
                  >
                    Basic - SaaS Landing Page
                  </h3> */}
                  <h2
                    className="header-title wow fadeInUp"
                    data-wow-duration="1.3s"
                    data-wow-delay="0.5s"
                  >
                    Terms & Conditions
                  </h2>
                  {/* <p
                    className="text wow fadeInUp"
                    data-wow-duration="1.3s"
                    data-wow-delay="0.8s"
                  >
                    Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed
                    diam nonumy eirmod tempor
                  </p>
                  <a
                    href="javascript:void(0)"
                    onClick={() => setOpen(!open)}
                    className="main-btn wow fadeInUp"
                    data-wow-duration="1.3s"
                    data-wow-delay="1.1s"
                  >
                    Get Started
                  </a> */}
                </div>
              </div>
            </div>
            <div style={{ height: 300 }}>

            </div>
          </div>
          <div id="particles-1" className="particles"></div>
        </div>

      </header>

      <section>
        <div style={{padding: '0 10%'}}>

          <p style={{marginTop: '20px'}}>
            <strong>Effective Date:</strong> 01 January 2024<br />
            <strong>Last Updated:</strong> 31 March 2026
          </p>

          <h2 style={{marginTop: '20px', marginBottom: '10px', fontSize: '22px'}}>1. Acceptance of Terms</h2>
          <p>
            By accessing or using <strong>Wareozo</strong> ("the Application", "the Platform"), a product of <strong>Purvish Infotech</strong> ("Company", "we", "our", "us"), you agree to be bound by these Terms of Use. If you do not agree, you must not use our services.
          </p>
          <p>
            In these Terms, "you", "yours" or similar expressions refer to any user of this website and the application. Terms such as "we", "us", "our" refer to Wareozo / Purvish Infotech.
          </p>
          <p>
            Please read these Terms carefully. By using the Website and App, you confirm that you accept these Terms and agree to comply with them. If you do not agree, please refrain from using the Website and App.
          </p>

          <h2 style={{marginTop: '40px', marginBottom: '10px', fontSize: '22px'}}>2. Other Applicable Terms</h2>
          <p>
            These Terms of Use should be read in conjunction with:
          </p>
          <ul style={{listStyleType: 'disc', paddingLeft: '20px', marginTop: '5px'}}>
            <li>Our <a href="/privacy-policy">Privacy Policy</a></li>
            <li>Our <a href="/opt-in">Communication Consent (Opt-In)</a> and <a href="/opt-out">Opt-Out</a> policies</li>
            <li>Meta's <a href="https://www.whatsapp.com/legal/business-terms" target="_blank" rel="noopener noreferrer">WhatsApp Business Terms of Service</a></li>
            <li>Meta's <a href="https://business.whatsapp.com/policy" target="_blank" rel="noopener noreferrer">WhatsApp Business Messaging Policy</a></li>
          </ul>

          <h2 style={{marginTop: '40px', marginBottom: '10px', fontSize: '22px'}}>3. Eligibility</h2>
          <p>
            Wareozo is intended for business and commercial use. By using the Platform, you represent that:
          </p>
          <ul style={{listStyleType: 'disc', paddingLeft: '20px', marginTop: '5px'}}>
            <li>You are at least 18 years of age (or the minimum age required by applicable law)</li>
            <li>You have the legal authority to enter into these Terms on behalf of yourself or the business you represent</li>
            <li>Your use of the Platform complies with all applicable laws and regulations</li>
          </ul>
          <p>
            If you are under 18, you may need your parent/guardian to assist you. Contact us at <a href="mailto:support@wareozo.com">support@wareozo.com</a> for any questions.
          </p>

          <h2 style={{marginTop: '40px', marginBottom: '10px', fontSize: '22px'}}>4. Service Description</h2>
          <p>
            Wareozo provides billing, invoicing, payment tracking, and business communication features including:
          </p>
          <ul style={{listStyleType: 'disc', paddingLeft: '20px', marginTop: '5px'}}>
            <li>Invoice creation, management, and delivery</li>
            <li>Payment tracking and reminders</li>
            <li>Business communication via WhatsApp (through Meta's WhatsApp Business API), SMS, and Email</li>
            <li>Integration with ERP/CRM systems to deliver Meta-approved template messages triggered by business events (invoices, payments, reminders, etc.)</li>
            <li>A messaging dashboard to manage, monitor, and audit message delivery</li>
            <li>Customer and supplier management (CRM features)</li>
            <li>Accounting and reporting tools</li>
          </ul>

          <h2 style={{marginTop: '40px', marginBottom: '10px', fontSize: '22px'}}>5. User Accounts & Responsibilities</h2>
          <p>
            When you create an account on Wareozo, you agree to:
          </p>
          <ul style={{listStyleType: 'disc', paddingLeft: '20px', marginTop: '5px'}}>
            <li>Provide accurate and complete business name, contact details, and registration information</li>
            <li>Maintain the confidentiality of your account credentials and not share them with unauthorized persons</li>
            <li>Accept responsibility for all activities that occur under your account</li>
            <li>Notify us immediately of any unauthorized use of your account</li>
            <li>Keep your account information up to date</li>
          </ul>

          <h2 style={{marginTop: '40px', marginBottom: '10px', fontSize: '22px'}}>6. WhatsApp Business API & Messaging Terms</h2>
          <p>
            If you use Wareozo's WhatsApp messaging features, you additionally agree to the following:
          </p>

          <div style={{paddingLeft: '24px'}}>
            <h3 style={{marginTop: '20px', marginBottom: '10px', fontSize: '18px'}}>6.1 Meta Business Account</h3>
            <p>
              You must maintain a verified Meta Business Account and WhatsApp Business Account (WABA) in good standing throughout your use of Wareozo. You are responsible for compliance with all Meta Business Platform policies.
            </p>

            <h3 style={{marginTop: '20px', marginBottom: '10px', fontSize: '18px'}}>6.2 Opt-In & Consent Requirements</h3>
            <p>
              You must obtain explicit, documented opt-in consent from your customers before sending them any WhatsApp, SMS, or Email communications through Wareozo. This includes:
            </p>
            <ul style={{listStyleType: 'disc', paddingLeft: '20px', marginTop: '5px'}}>
              <li>Collecting consent clearly and separately for different message categories (transactional, promotional, updates)</li>
              <li>Maintaining records of all consents obtained (date, time, method, and scope)</li>
              <li>Providing clear opt-out instructions in every communication</li>
              <li>Honoring opt-out requests promptly (within 48 hours)</li>
            </ul>
            <p>
              Wareozo provides an <a href="/opt-in">Opt-In form</a> and <a href="/opt-out">Opt-Out form</a> to assist with consent management, but you are solely responsible for ensuring valid consent is obtained from your customers.
            </p>

            <h3 style={{marginTop: '20px', marginBottom: '10px', fontSize: '18px'}}>6.3 Approved Message Templates</h3>
            <p>
              You must only use Meta-approved message templates through the Wareozo platform. Templates must be used only for their approved and designated purpose. Modifying, misrepresenting, or misusing template categories is a violation of these Terms and Meta's policies.
            </p>

            <h3 style={{marginTop: '20px', marginBottom: '10px', fontSize: '18px'}}>6.4 WhatsApp Data Restrictions</h3>
            <p>
              Data obtained through WhatsApp communications must only be used for the purpose for which it was collected. You must not:
            </p>
            <ul style={{listStyleType: 'disc', paddingLeft: '20px', marginTop: '5px'}}>
              <li>Use WhatsApp data for advertising, profiling, retargeting, or data brokering</li>
              <li>Share WhatsApp data with third parties for marketing purposes</li>
              <li>Combine WhatsApp data with other data sets for purposes beyond the original communication</li>
              <li>Request or transmit sensitive data (payment card numbers, CVV, passwords, OTPs, national IDs) through WhatsApp</li>
            </ul>

            <h3 style={{marginTop: '20px', marginBottom: '10px', fontSize: '18px'}}>6.5 Message Frequency</h3>
            <p>
              You must maintain reasonable messaging frequency and not send excessive messages to your customers. Sending high volumes of unsolicited or irrelevant messages may result in account suspension by Meta and/or Wareozo.
            </p>
          </div>

          <h2 style={{marginTop: '40px', marginBottom: '10px', fontSize: '22px'}}>7. Prohibited Uses</h2>
          <p>
            You must not use Wareozo to:
          </p>
          <ul style={{listStyleType: 'disc', paddingLeft: '20px', marginTop: '5px'}}>
            <li>Send spam, unsolicited, or unauthorized messages</li>
            <li>Send promotional messages to recipients who have not explicitly opted in</li>
            <li>Transmit content that is illegal, harmful, threatening, abusive, defamatory, or otherwise objectionable</li>
            <li>Impersonate any person or entity, or misrepresent your affiliation with any person or entity</li>
            <li>Violate any applicable local, national, or international law or regulation</li>
            <li>Attempt to gain unauthorized access to the Platform, other accounts, or connected systems</li>
            <li>Introduce viruses, malware, or other malicious code</li>
            <li>Conduct denial-of-service attacks or any action that disrupts the Platform</li>
            <li>Scrape, harvest, or collect data from the Platform without authorization</li>
            <li>Use the Platform for any activity that violates Meta's WhatsApp Business Policy or Commerce Policy</li>
          </ul>
          <p>
            Violation of these prohibited uses may result in immediate account suspension or termination and may be reported to relevant law enforcement authorities.
          </p>

          <h2 style={{marginTop: '40px', marginBottom: '10px', fontSize: '22px'}}>8. Intellectual Property</h2>
          <p>
            The Wareozo website, application, and all related content — including but not limited to software, design, text, graphics, logos, icons, and trademarks — are the property of Purvish Infotech and are protected by applicable intellectual property laws. All rights are reserved.
          </p>
          <p>
            You may not reproduce, distribute, modify, create derivative works from, publicly display, or exploit any part of the Platform without our prior written consent.
          </p>

          <h2 style={{marginTop: '40px', marginBottom: '10px', fontSize: '22px'}}>9. Payment & Subscription Terms</h2>
          <p>
            Certain features of Wareozo may require a paid subscription. By subscribing, you agree that:
          </p>
          <ul style={{listStyleType: 'disc', paddingLeft: '20px', marginTop: '5px'}}>
            <li>All fees are as listed on our <a href="/signin#pricing">Pricing</a> page at the time of purchase</li>
            <li>Payments are due as per the selected billing cycle (monthly/annually)</li>
            <li>Subscriptions may auto-renew unless cancelled before the renewal date</li>
            <li>Refunds, if applicable, are handled as per our refund policy communicated at the time of purchase</li>
            <li>We reserve the right to modify pricing with reasonable prior notice</li>
          </ul>
          <p>
            Failure to make timely payments may result in suspension or downgrade of your account.
          </p>

          <h2 style={{marginTop: '40px', marginBottom: '10px', fontSize: '22px'}}>10. Third-Party Services</h2>
          <p>
            Wareozo integrates with and relies on third-party services, including but not limited to:
          </p>
          <ul style={{listStyleType: 'disc', paddingLeft: '20px', marginTop: '5px'}}>
            <li>Meta / WhatsApp Business Platform for WhatsApp messaging</li>
            <li>SMS gateway providers for SMS delivery</li>
            <li>Email service providers for email delivery</li>
            <li>Cloud hosting and infrastructure providers</li>
            <li>Payment processing providers</li>
          </ul>
          <p>
            We are not responsible for the availability, performance, or policies of these third-party services. Your use of these services may also be subject to their own terms and conditions. Disruptions or changes to third-party services (including Meta's WhatsApp Business API) may impact the availability of certain Wareozo features, and we shall not be held liable for such disruptions.
          </p>

          <h2 style={{marginTop: '40px', marginBottom: '10px', fontSize: '22px'}}>11. Changes to the Platform</h2>
          <p>
            We aim to update the Platform regularly and may change the content, features, or functionality at any time. We may suspend access to the Platform, or discontinue any feature, with or without notice. We will not be liable if the Platform or any part of it is unavailable at any time.
          </p>

          <h2 style={{marginTop: '40px', marginBottom: '10px', fontSize: '22px'}}>12. Changes to These Terms</h2>
          <p>
            We may update these Terms from time to time. When significant changes are made, we will notify you through the application, website, email, or other appropriate channels. The updated version will always include the latest "Last Updated" date. Continued use of the Platform after changes constitutes acceptance of the revised Terms.
          </p>

          <h2 style={{marginTop: '40px', marginBottom: '10px', fontSize: '22px'}}>13. Account Suspension & Termination</h2>
          <p>
            We reserve the right to suspend or terminate your account at our discretion if:
          </p>
          <ul style={{listStyleType: 'disc', paddingLeft: '20px', marginTop: '5px'}}>
            <li>You violate these Terms of Use</li>
            <li>You violate Meta's WhatsApp Business Policy or any applicable third-party terms</li>
            <li>Your messaging behavior results in complaints, blocks, or quality rating degradation</li>
            <li>You fail to make required payments</li>
            <li>We are required to do so by law or regulatory order</li>
          </ul>
          <p>
            Upon termination:
          </p>
          <ul style={{listStyleType: 'disc', paddingLeft: '20px', marginTop: '5px'}}>
            <li>Your access to the Platform will be revoked</li>
            <li>Your data will be retained as per our <a href="/privacy-policy">Privacy Policy</a> and applicable legal requirements</li>
            <li>You may request export of your data within 30 days of termination by contacting <a href="mailto:support@wareozo.com">support@wareozo.com</a></li>
            <li>Outstanding fees remain due and payable</li>
          </ul>
          <p>
            You may also terminate your account at any time by contacting us at <a href="mailto:support@wareozo.com">support@wareozo.com</a>.
          </p>

          <h2 style={{marginTop: '40px', marginBottom: '10px', fontSize: '22px'}}>14. Limitation of Liability</h2>
          <p>
            To the maximum extent permitted by applicable law:
          </p>
          <ul style={{listStyleType: 'disc', paddingLeft: '20px', marginTop: '5px'}}>
            <li>The Platform is provided on an "as is" and "as available" basis without warranties of any kind, whether express or implied</li>
            <li>We do not warrant that the Platform will be uninterrupted, error-free, or secure</li>
            <li>We are not responsible for any data loss, security breaches, or service interruptions caused by factors beyond our reasonable control</li>
            <li>We are not liable for any indirect, incidental, special, consequential, or punitive damages arising from your use of the Platform</li>
            <li>Our total liability for any claims arising from these Terms shall not exceed the amount paid by you to us in the 12 months preceding the claim</li>
          </ul>
          <p>
            We do not guarantee the delivery of WhatsApp, SMS, or Email messages, as delivery depends on third-party service providers, network conditions, and recipient device availability.
          </p>

          <h2 style={{marginTop: '40px', marginBottom: '10px', fontSize: '22px'}}>15. Indemnification</h2>
          <p>
            You agree to indemnify, defend, and hold harmless Purvish Infotech, its officers, directors, employees, and agents from and against any claims, liabilities, damages, losses, and expenses (including legal fees) arising out of or related to:
          </p>
          <ul style={{listStyleType: 'disc', paddingLeft: '20px', marginTop: '5px'}}>
            <li>Your use of the Platform</li>
            <li>Messages sent through the Platform on your behalf</li>
            <li>Your violation of these Terms or any applicable law</li>
            <li>Your failure to obtain proper consent from message recipients</li>
            <li>Any complaint or action brought by a third party (including Meta) related to your messaging practices</li>
          </ul>

          <h2 style={{marginTop: '40px', marginBottom: '10px', fontSize: '22px'}}>16. Governing Law & Jurisdiction</h2>
          <p>
            These Terms shall be governed by and construed in accordance with the laws of India. Any disputes arising out of or in connection with these Terms shall be subject to the exclusive jurisdiction of the courts of <strong>Nagpur, Maharashtra, India</strong>.
          </p>

          <h2 style={{marginTop: '40px', marginBottom: '10px', fontSize: '22px'}}>17. Dispute Resolution</h2>
          <p>
            In the event of any dispute arising out of these Terms, both parties agree to first attempt resolution through good-faith negotiation. If a resolution cannot be reached within 30 days, either party may initiate formal proceedings as per Section 16.
          </p>
          <p>
            For complaints related to messaging or data practices, please contact our Grievance Officer as listed in our <a href="/privacy-policy">Privacy Policy</a>.
          </p>

          <h2 style={{marginTop: '40px', marginBottom: '10px', fontSize: '22px'}}>18. Severability</h2>
          <p>
            If any provision of these Terms is found to be invalid or unenforceable by a court of competent jurisdiction, the remaining provisions shall continue in full force and effect.
          </p>

          <h2 style={{marginTop: '40px', marginBottom: '10px', fontSize: '22px'}}>19. Company Information</h2>
          <p>
            <strong>Purvish Infotech</strong><br />
            Website: <a href="https://purvishinfotech.com" target="_blank" rel="noopener noreferrer">https://purvishinfotech.com</a><br />
            Product: <a href="https://wareozo.com" target="_blank" rel="noopener noreferrer">https://wareozo.com</a><br />
            Email: <a href="mailto:support@wareozo.com">support@wareozo.com</a><br />
            Address: 121, Sai Nagar, Near HBL Tower, Nagpur, Maharashtra - 441108
          </p>

          <h2 style={{marginTop: '40px', marginBottom: '10px', fontSize: '22px'}}>20. Contact Us</h2>
          <p>
            If you have any questions about these Terms of Use, please contact us:
          </p>
          <p>
            <strong>Wareozo</strong><br />
            Email: <strong><a href="mailto:support@wareozo.com">support@wareozo.com</a></strong><br />
            Website: <a href="https://wareozo.com" target="_blank" rel="noopener noreferrer">https://wareozo.com</a><br />
            Privacy Policy: <a href="/privacy-policy">https://wareozo.com/privacy-policy</a>
          </p>

        </div>
      </section>


      <footer id="footer" className="footer-area pt-120">
        <div className="container">
          <div
            className="subscribe-area wow fadeIn"
            data-wow-duration="1s"
            data-wow-delay="0.5s"
          >
            <div className="row align-items-center">
              <div className="col-lg-8">
                <div className="subscribe-content mt-45">
                  <h2 className="subscribe-title">
                    Stay Connected <span>subscribe to our communication channels</span>
                  </h2>
                </div>
              </div>
              <div className="col-lg-4">
                <div className="mt-45" style={{ textAlign: 'right' }}>
                  <a href="/opt-in" style={{ textDecoration: 'none', padding: '12px 36px', borderRadius: '30px', backgroundColor: '#059669', color: '#fff', fontSize: '16px', fontWeight: 600, display: 'inline-block' }}>Subscribe Now</a>
                </div>
              </div>
            </div>

          </div>
          <div className="footer-widget pb-100">
            <div className="row">
              <div className="col-lg-4 col-md-6 col-sm-8">
                <div
                  className="footer-about mt-50 wow fadeIn"
                  data-wow-duration="1s"
                  data-wow-delay="0.2s"
                >
                  <a className="logo" href="javascript:void(0)">
                    <img src={Img0} alt="Wareozo" style={{ width: 80 }} />
                    <img src={Img1} alt="Wareozo" />
                  </a>
                  <p className="text">
                    Simplify invoicing, automate accounting, and boost business growth with smart, secure, and efficient wareozo billing software. 
                  </p>
                  <ul className="social">
                    <li>
                      <a href="javascript:void(0)">
                        <i className="lni lni-facebook-filled"> </i>
                      </a>
                    </li>
                    <li>
                      <a href="javascript:void(0)">
                        <i className="lni lni-twitter-filled"> </i>
                      </a>
                    </li>
                    <li>
                      <a href="javascript:void(0)">
                        <i className="lni lni-instagram-filled"> </i>
                      </a>
                    </li>
                    <li>
                      <a href="javascript:void(0)">
                        <i className="lni lni-linkedin-original"> </i>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-lg-5 col-md-7 col-sm-12">
                <div className="footer-link d-flex mt-50 justify-content-sm-between">
                  <div
                    className="link-wrapper wow fadeIn"
                    data-wow-duration="1s"
                    data-wow-delay="0.4s"
                  >
                    <div className="footer-title">
                      <h4 className="title">Quick Link</h4>
                    </div>
                    <ul className="link">
                      <li><a href="/privacy-policy">Privacy Policy</a></li>
                      <li><a href="/terms-of-use">Terms of Service</a></li>
                      <li><a href="/signin#pricing">Pricing</a></li>
                      <li><a href="/signin#faq">FAQ</a></li>
                      <li><a href="/opt-out">Unsubscribe</a></li>
                    </ul>
                  </div>

                  <div
                    className="link-wrapper wow fadeIn"
                    data-wow-duration="1s"
                    data-wow-delay="0.6s"
                  >
                    <div className="footer-title">
                      <h4 className="title">Resources</h4>
                    </div>
                    <ul className="link">
                      <li><a href="/signin#home">Home</a></li>
                      <li><a href="/signin#features">Features</a></li>
                      <li><a href="/signin#about">About</a></li>
                      <li><a href="/signin#why">Why</a></li>
                    </ul>
                  </div>

                </div>
              </div>
              <div className="col-lg-3 col-md-5 col-sm-12">
                <div
                  className="footer-contact mt-50 wow fadeIn"
                  data-wow-duration="1s"
                  data-wow-delay="0.8s"
                >
                  <div className="footer-title">
                    <h4 className="title">Contact Us</h4>
                  </div>
                  <ul className="contact">
                    <li>support@wareozo.com</li>
                    <li>www.wareozo.com</li>
                    <li>
                      121, Sai Nagar, Near HBL Tower, <br /> Nagpur, Maharashtra - 441108 
                    </li>
                  </ul>
                </div>
              </div>
            </div>

          </div>
          <div className="footer-copyright">
            <div className="row">
              <div className="col-lg-12">
                <div className="copyright d-sm-flex justify-content-between">
                  <div className="copyright-content">
                    <p className="text">
                      Designed and Developed by 
                      <a href="javascript:void(0)" rel="nofollow"> &nbsp; Wareozo</a>
                    </p>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>

        <div id="particles-2"></div>
      </footer>

      <a href="#" className="back-to-top"> <i className="lni lni-chevron-up"> </i> </a>

      <Modal open={open} onClose={(event: any, reason: any) => {
        if (reason && reason == "backdropClick" && "escapeKeyDown")
          setOpen(false);
      }}>
        <div className='centerme'>
          <div className={`${isMobile ? 'maindiv2' : 'maindiv'}`}>
            <div style={{ width: isMobile ? '100%' : '50%' }}>
              {type === '0' ? <SigninForm setType={setType} /> : type === '1' ? <SignUpForm setType={setType} /> : <ForgotPassword setType={setType} />}
            </div>
            {!isMobile && <div style={{ width: '50%' }}>
              <img src={BgImg2} />
            </div>}
          </div>

          {/* <div style={{backgroundImage: `url(${BgImg0})`, padding: 20,paddingTop:40, paddingBottom:40, width:'100%', height:'auto',margin:'auto',display:'flex',flexDirection:'row'}}>
            {type === '0' ? <SigninForm setType={setType} /> : type === '1' ? <SignUpForm setType={setType}/> : <ForgotPassword setType={setType}/>}
            </div> */}

        </div>
      </Modal>

      {/* <Helmet>
      <script src="js/bootstrap.bundle.min.js" type="text/javascript"></script>
    <script src="js/wow.min.js" type="text/javascript"></script>
    <script src="js/glightbox.min.js" type="text/javascript"></script>
    <script src="js/count-up.min.js" type="text/javascript"></script>
    <script src="js/particles.min.js" type="text/javascript"></script>
    <script src="js/main.js" type="text/javascript"></script>
      </Helmet> */}

      {/* {AddLibrary("./js/bootstrap.bundle.min.js")}
      {AddLibrary("./js/wow.min.js")}
      {AddLibrary("./js/glightbox.min.js")}
      {AddLibrary("./js/count-up.min.js")}
      {AddLibrary("./js/particles.min.js")}
      {AddLibrary("./js/main.js")} */}
    </>
  );
}

export default TermsConditions;

